import React from 'react'

const IconArrow = ({fillColor,style}) => {
  return (
 
   <svg xmlns="http://www.w3.org/2000/svg" className={'search-icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
    <path d="M140-190v-580l688.46 290L140-190Zm60-90 474-200-474-200v147.69L416.92-480 200-427.69V-280Zm0 0v-400 400Z"/>
            </svg>
  )
}
export default IconArrow